import LogoDefault from "./Logo";

export default LogoDefault;
